<template>
  <router-view />
  <div class="allFooter">
    <div class="fotInfo">
      <div class="one">
        <div class="detail">
          <img src="../static/images/fot0.png" class="left">
          <div class="right">
            <div class="title">正品保证</div>
            <div class="tips">正品保障，专业品质</div>
          </div>
        </div>
        <div class="detail">
          <img src="../static/images/fot1.png" class="left">
          <div class="right">
            <div class="title">货期保证</div>
            <div class="tips">承诺货期，物流追踪</div>
          </div>
        </div>
        <!-- <div class="detail">
          <img src="../static/images/fot2.png" class="left">
          <div class="right">
            <div class="title">满额包邮</div>
            <div class="tips">满足一定金额，免费包邮</div>
          </div>
        </div> -->
        <div class="detail">
          <img src="../static/images/fot4.png" class="left">
          <div class="right">
            <div class="title">多仓直发</div>
            <div class="tips">多地仓库，就近发货</div>
          </div>
        </div>
        <div class="detail">
          <img src="../static/images/fot3.png" class="left">
          <div class="right">
            <div class="title">一站式服务</div>
            <div class="tips">在线客服，周到服务</div>
          </div>
        </div>

      </div>
      <div class="two">
        <!-- <div class="left">
          <div class="detail">
            <div class="title">技术服务</div>
            <router-link :to="'/Fuwuxiangqing?id=' + item.id + ''" class="tips" v-for="(item, index) in serCateList"
              :key="index + 'jsfw'" target="_blank">{{ item.title }}</router-link>
          </div>
          <div class="detail">
            <div class="title">行业资讯</div>
            <router-link :to="'/News?id=' + item.id + ''" class="tips" v-for="(item, index) in newsCateList"
              :key="index + 'jsfw'" target="_blank">{{ item.title }}</router-link>
          </div>
          <div class="detail">
            <div class="title">特色服务</div>
            <div class="tips" @click="gotoSysq">试样申请</div>
            <div class="tips" @click="gotoLsdz">量身定制</div>
            <div class="tips" @click="gotoHzsp">合作商品</div>
            <div class="tips" @click="gotoWdxj">我的询价</div>
          </div>
          <div class="detail">
            <div class="title">帮助中心</div>
            <div class="tips" @click="gotoLogin">商城登录</div>
            <div class="tips">下单流程</div>
            <div class="tips">用户特权</div>
          </div>
        </div> -->
        <div class="left">
          <div class="detail">
            <div class="title">购物指南</div>
            <a href="/HelpCenter" target="_blank" class="tips">帮助中心</a>
            <a href="/Hyzx_qiyerenzheng_dai" target="_blank" class="tips">企业认证</a>
          </div>
          <div class="detail">
            <div class="title">付款方式</div>
            <a href="/HelpCenter" target="_blank" class="tips">付款及开票信息</a>
          </div>
          <div class="detail">
            <div class="title">服务政策</div>
            <a href="/HelpCenter" target="_blank" class="tips">售后服务</a>
            <a href="/Fuwuxieyi" target="_blank" class="tips">服务协议</a>
            <a href="/Yinsizhengce" target="_blank" class="tips">隐私协议</a>
          </div>
          <div class="detail">
            <div class="title">关于我们</div>
            <a href="/AboutUsTwo" target="_blank" class="tips">公司介绍</a>
          </div>
        </div>
        <div class="middle">
          <img src="../static/images/fot5.png" class="midLeft">
          <div class="midRight">
            <div class="title">{{ message.Web_Tel }}</div>
            <div class="tips">{{ message.Kf_Date }}</div>
            <div class="tips">{{ message.Kf_Date2 }}</div>
          </div>
        </div>
        <div class="right">
          <div class="detail">
            <img :src="message.Xcx_Qr" class="imgs">
            <div class="name">微信小程序</div>
          </div>
          <div class="detail">
            <img :src="message.Service_Qr" class="imgs">
            <div class="name">专属客服</div>
          </div>
        </div>
      </div>
      <div class="three">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> {{ message.COPYRIGHT_ALL }}</a>
        <img src="../static/images/gov.png" alt="">
        <a :href="message.WEB_SITE_ICP_URL" target="_blank">{{ message.WEB_SITE_ICP }}</a>
      </div>

    </div>
  </div>
</template>
<style>
@import url("./css/myCommon.css");
@import url("./css/yCommon.css");
</style>
<script>
import http from "./http/api";
export default {
  components: {
    
  },
  data () {
    return {
      serCateList:[],//技术服务类型
      newsCateList:[],//行业资讯
      message:"",//各类信息
    };
  },

  created () {//页面渲染之前

  },
  mounted () {//页面渲染之后
    let that = this;
    // 技术服务类型
    http.post("/service/list.html",{}).then(res=>{
      that.serCateList = res.data.list;
    })
    // 行业资讯
    http.post("/news/category.html",{}).then(res=>{
      that.newsCateList = res.data.list;
    })
    // 二维码
    http.post("/common/config.html",{}).then(res=>{
      that.message = res.data
    })
    if (localStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(localStorage.getItem('store'))
        )
      )
    }
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  methods: {//事件
    // 前往试样申请
    gotoSysq(){
      let that = this;
      if(!that.$store.state.token){
        that.$message.warning("请先登录");
        return false;
      }
      let routeUrl = that.$router.resolve('/Hhfw_wodishiyang');
      window.open(routeUrl.href, '_blank');
    },
    // 前往量身定制
    gotoLsdz(){
      let that = this;
      if(!that.$store.state.token){
        that.$message.warning("请先登录");
        return false;
      }
      let routeUrl = that.$router.resolve('/Hhfw_liangshendingzhi');
      window.open(routeUrl.href, '_blank');
    },
    // 前往合作商品
    gotoHzsp(){
      let that = this;
      if(!that.$store.state.token){
        that.$message.warning("请先登录");
        return false;
      }
      let routeUrl = that.$router.resolve('/Hhfw_hezuoshangpin');
      window.open(routeUrl.href, '_blank');
    },
    // 前往我的询价
    gotoWdxj(){
      let that = this;
      if(!that.$store.state.token){
        that.$message.warning("请先登录");
        return false;
      }
      let routeUrl = that.$router.resolve('/Hyzx_wodexunjia');
      window.open(routeUrl.href, '_blank');
    },
    // 前往登录
    gotoLogin(){
      this.$router.push("/Login")
    },
  },
};
</script>
